// extracted by mini-css-extract-plugin
export default {"stickyScrollable":"RSCatalogSatelliteNav_stickyScrollable__ciEdP"};